export default __webpack_public_path__ + "static/media/312.8857523c.svg";